import { computed, action, reaction, observable } from 'mobx';
import Rusha from 'rusha';

export const MAX_CONCURRENT_UPLOADS = 4;

export class Uploader {
  @observable queue;
  @observable uploads;
  @observable fastTrack;
  @observable workers;
  constructor() {
    this.queue = [];
    this.uploads = [];
    this.fastTrack = [];
    this.workers = new Array(MAX_CONCURRENT_UPLOADS);
    this.workers = this.workers.map(() => Rusha.createWorker());
    /*
     * FIXME - Will the reaction ever will disposed?
     * This runs inside the ClientStore singleton. Maybe not needed?
     */
    // eslint-disable-next-line
    const disposer = reaction(
      () => this.occupation,
      () => this.processIfSpot(),
    );
  }

  @computed get occupation() {
    return this.queue.length + this.uploads.length;
  }

  @computed get uploadsQueue() {
    return [...this.uploads, ...this.fastTrack];
  }

  @action processIfSpot = () => {
    if (
      this.queue.length > 0 &&
      this.workers.length > 0 &&
      this.uploads.length < MAX_CONCURRENT_UPLOADS
    ) {
      const queuedFile = this.queue.pop();
      const hashingWorker = this.workers.pop();
      this.uploads.push(queuedFile);
      this.uploadFile(queuedFile, hashingWorker);
    }
  };

  @action QueueFile(
    fileManager,
    file,
    uploadedCallback = () => {},
    cancelledCallback = () => {},
  ) {
    fileManager.SetLocalFile(file.fileObject);
    fileManager.SetUploadedCallback(completeFile => {
      uploadedCallback(completeFile);
      this.uploadComplete(completeFile);
    });
    fileManager.SetUploadCancelledCallback(cancelledFile => {
      cancelledCallback(cancelledFile);
      this.uploadComplete(cancelledFile);
    });
    this.queue.push(fileManager);
    return fileManager;
  }

  @action FastTrackFile(
    fileManager,
    file,
    uploadedCallback = () => {},
    cancelledCallback = () => {},
  ) {
    fileManager.SetLocalFile(file.fileObject);
    fileManager.SetUploadedCallback(completeFile => {
      uploadedCallback(completeFile);
      this.fastTrackComplete(completeFile);
    });
    fileManager.SetUploadCancelledCallback(cancelledFile => {
      cancelledCallback(cancelledFile);
      this.uploadComplete(cancelledFile);
    });
    this.fastTrack.push(fileManager);
    this.uploadFile(fileManager);
    return fileManager;
  }

  @action uploadComplete = file => {
    this.uploads = this.uploads.filter(upload => upload.file.id !== file.id);
  };

  @action fastTrackComplete = file => {
    this.fastTrack = this.fastTrack.filter(
      upload => upload.file.id !== file.id,
    );
  };

  @action uploadFile(fileManager, hashingWorker) {
    const { file } = fileManager;
    const blobHeader = `blob ${file.size}\0`;
    const gitBlob = new Blob([blobHeader, file.localFile.slice()]);

    const hashingWorkerProvided = !!hashingWorker;

    if (!hashingWorkerProvided) {
      hashingWorker = Rusha.createWorker();
    }

    hashingWorker.onmessage = e => {
      fileManager.SetHash(e.data.hash);
      fileManager.SyncFile();
      if (hashingWorkerProvided) {
        this.workers.push(hashingWorker);
      } else {
        hashingWorker.terminate();
      }
    };

    hashingWorker.postMessage({ id: file.filename, data: gitBlob });
  }
}
